import React from 'react'

export default function Errors({ errors=[] }) {
  return <div>Something went wrong. Sorry.</div>
}
